import $ajax from "./request"
import {getUrlQueryValueByKey, getQueryParams} from "./util";

const BaseUrl = location.origin;
const queryParams = getQueryParams();

const getAwardList = () => {
    return new Promise(resolve => {
        $ajax.get(BaseUrl + '/app/wx/draw/getRecord', { userId: getUrlQueryValueByKey(location.href, 'userId'), actId: getUrlQueryValueByKey(location.href, 'actId') }).then(res => {
            const { data } = res;
            resolve(data);
        })
    })
}

const addLog = (accessRefer, pageFlg, activityId, userId) => {
    return new Promise(resolve => {
        $ajax.get(BaseUrl + '/app/wx/access/addLog', {  userId: userId || getUrlQueryValueByKey(location.href, 'userId'), accessRefer, pageFlg, shopId: '' , memo: activityId}).then(res => {
            const { data } = res;
            resolve(data);
        })
    })
}
const clickShareLink = (beSharedUserId, shareUnionId) => {
    return new Promise(resolve => {
        $ajax.post(BaseUrl + '/app/wx/share/clickShareUrl', { source:'sms',beSharedUserId,shareUnionId }).then(res => {
            const { data } = res;
            resolve(data);
        })
    })
}
const shareLink = (pageUrl, shareIds, goodsId, titleS, imageUrl) => {
    return new Promise(resolve => {
        $ajax.get(BaseUrl + '/app/wx/access/shareLink', { pageUrl, shareIds, goodsId, titleS, imageUrl }).then(res => {
            const { data } = res;
            resolve(data);
        })
    })
}

const queryDrawRecordList = () => {
    return new Promise(resolve => {
        $ajax.get(BaseUrl + '/app/wx/draw/queryDrawRecordList', { userId: getUrlQueryValueByKey(location.href, 'userId'), actId: getUrlQueryValueByKey(location.href, 'actId') }).then(res => {
            const { data } = res;
            resolve(data);
        })
    })
}

const queryDrawRecordListByActId = (actId) => {
    let urlActId =getUrlQueryValueByKey(location.href, 'actId')
    if(urlActId === '' || urlActId == null || urlActId === 'undefined'){
        urlActId = actId
    }
    return new Promise(resolve => {
        $ajax.get(BaseUrl + '/app/wx/draw/queryDrawRecordList', { userId: getUrlQueryValueByKey(location.href, 'userId'), actId: urlActId }).then(res => {
            const { data } = res;
            resolve(data);
        })
    })
}
const getAddGiveTimes = () => {
    return new Promise(resolve => {
        $ajax.get(BaseUrl + '/app/wx/draw/addGiveTimes', { userId: getUrlQueryValueByKey(location.href, 'userId'), actId: getUrlQueryValueByKey(location.href, 'actId') }).then(res => {
            const { data } = res;
            resolve(data);
        })
    })
}

const getAddGiveTimesByActId = (actId) => {

    let urlActId =getUrlQueryValueByKey(location.href, 'actId')
    if(urlActId === '' || urlActId == null || urlActId === 'undefined'){
        urlActId = actId
    }
    return new Promise(resolve => {
        $ajax.get(BaseUrl + '/app/wx/draw/addGiveTimes', { userId: getUrlQueryValueByKey(location.href, 'userId'), actId: urlActId }).then(res => {
            const { data } = res;
            resolve(data);
        })
    })
}

const getAddressList = () => {
    return new Promise(resolve => {
        $ajax.get(BaseUrl + '/app/wx/address/list', { userId: getUrlQueryValueByKey(location.href, 'userId') }).then(res => {
            const { data } = res;
            resolve(data);
        })
    })
}



const updateAddress = (cargoNo, recipient, mobile, receiverAddress) => {
    return new Promise(resolve => {
        $ajax.post(BaseUrl + '/app/wx/draw/updateAddress', {
            cargoNo: cargoNo,
            recipient: recipient,
            mobile: mobile,
            receiverAddress: receiverAddress
        }).then(res => {
            const {data} = res;
            resolve(data);
        })
    })
}

export {
    getAwardList,
    clickShareLink,
    shareLink,
    addLog,
    queryDrawRecordList,
    queryDrawRecordListByActId,
    getAddressList,
    updateAddress,
    getAddGiveTimesByActId,
    getAddGiveTimes
}
